export default __webpack_public_path__ + "static/media/trifence.6dd284d3.svg";